import { categories } from "@/mocks/gossipData";

export default function Categories() {
  return (
    <section id="channel" className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-xl mb-8 md:mb-10">
          <p className="text-accent-600 font-heading text-sm mb-1">CHANNELS</p>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">分类频道</h2>
          <p className="text-sm text-foreground-600">按兴趣挑频道，想围观哪路瓜，就往哪头钻</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href="#topics"
              className="group relative aspect-[4/3] rounded-2xl overflow-hidden border border-background-200 hover:border-background-300 transition-colors"
            >
              <img
                src={cat.image}
                alt={`${cat.name} 频道封面`}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5 text-white">
                <span className="inline-flex items-center gap-1.5 mb-2 w-8 h-8 rounded-full bg-white/15 backdrop-blur border border-white/25 items-center justify-center">
                  <i className={`${cat.icon} text-accent-300`}></i>
                </span>
                <h3 className="font-heading text-lg md:text-xl mb-1">{cat.name}</h3>
                <p className="text-xs md:text-sm text-white/75 mb-2 line-clamp-1">{cat.desc}</p>
                <span className="text-xs text-white/60">{cat.count} 条内容</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}